import * as actions from '../../redux/actions';
import * as commonActions from '../../../common/redux/actions';
import * as homeActions from '../../../home/redux/actions';
import * as myAccountActions from '../../../my-account/redux/actions';
import * as serviceActions from '../../../pb-service-list/redux/actions';

import { KuposDatePicker, KuposInput, KuposModal, KuposSelectBox, SvgHome } from '../../../common';
import React, { useRef, useState } from 'react';

import ApiUrls from '../../../../services/apiUrls';
import CancelTicketInput from '../../ThemeTen/components/cancel-input';
import ChangeTicketInput from '../../ThemeTen/components/change-ticket-input';
import CommonService from '../../../../services/commonService';
import CuponeraInput from '../../ThemeTen/components/copunera-inputs';
import DateService from '../../../../services/dateService';
import SearchInput from '../../ThemeTen/components/search-input';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

const getTabs = operator => {

	const defaultTabs = [
		{
			active: true,
			id: '434',
			label: 'COMPRAR PASAJE',
			activeIcon: 'BA',
			InActiveIcon: operator && operator.operator_name === 'chilebus' ? 'BIA' : 'BA',
			component: props => <SearchInput data={props} />,
		},

		{
			active: false,
			id: '32',
			label: 'ANULAR PASAJE',
			activeIcon: 'CA',
			InActiveIcon: operator && operator.operator_name === 'chilebus' ? 'CIA' : operator && operator.operator_name === 'santajuana' ? 'CA' : 'BA',
			component: props => <CancelTicketInput data={props} />,
		},
	];


	if (operator && operator.is_change_ticket) {
		defaultTabs.push({
			active: false,
			id: '3r4',
			label: 'CAMBIAR PASAJE',
			activeIcon: 'CTA',
			InActiveIcon: 'CTA',
			is_change_ticket: true,
			component: (props, changeTicket) => (
				<ChangeTicketInput data={props} changeTicket={changeTicket} />
			),
		});
	}
	if (operator && operator.is_couponera_enabled) {
		defaultTabs.push(
			{
				active: false,
				id: '3',
				label: 'CONFIRMAR PASAJE',
				activeIcon: 'CCA',
				InActiveIcon: 'CCA',
				component: props => <SearchInput data={props} is_mot />,
			},

			{
				active: false,
				id: '4',
				label: 'CUPONERA',
				activeIcon: 'CUA',
				InActiveIcon: 'CUA',
				component: props => <CuponeraInput data={props} />,
			},
		);
	}

	return defaultTabs;
};

const ThemeFourSearchBox = props => {

	const { operator } = props;
	const tabs = getTabs(operator);
	const [selectedTab, setSelectedTab] = useState(tabs[0]);
	const [changeTicket, setChangeTicket] = useState(false);

	const handleChangeTab = item => {
		setSelectedTab(item);
		setChangeTicket(item.is_change_ticket ? true : false);
		localStorage.setItem('isChangeTicket', item.is_change_ticket ? true : false);
	};

	const getStyle = selected => {
		if (operator.operator_name === 'pullmandelsur') {
			return {
				background: selected
					? operator.color_codes.search_active_tab
					: operator.color_codes.search_inactive_tab,
				color: 'white',
			};
		}
		if (operator.operator_name === 'tacoha') {
			return {
				background: selected ? 'rgb(12, 44, 154)' : 'rgb(103, 122, 188)',
				color: 'white',
			};
		}
		if (operator.operator_name === 'sanantonio') {
			return {
				background: selected ? 'rgb(230, 98, 17)' : 'rgb(238, 147, 2)',
				color: 'white',
			};
		}
		if (operator.operator_name === 'liquine') {
			return {
				background: selected ? 'rgb(128, 214, 51)' : 'rgb(77, 173, 39)',
				color: 'white',
			};
		}
		if (operator.operator_name === 'chilebus') {
			return {
				background: selected ? 'rgb(255, 255, 255)' : 'rgb(10, 70, 158)',
				color: selected ? '#464647' : '#fff',
			};
		}
		// if (operator.operator_name === 'saopaulo') {
		//   return {
		//     background: selected ? 'rgb(127, 2, 164, 1)' : 'rgb(154, 96, 221, 1)',
		//     color: 'white',
		//   };
		// }
		if (operator.operator_name === 'saopaulo' || 'santajuana') {
			return {
				background: selected
					? operator.color_codes.search_active_tab
					: operator.color_codes.search_inactive_tab,
				color: 'white',
			};
		}
	};

	const tabItem = item => {
		const selected = selectedTab.id === item.id;



		return (

			operator && operator.operator_name === 'chilebus' ?
				(<div
					className={`${tabs.length > 2 && 'flex1'} tab d-flex-c bold-text`}
					onClick={() => handleChangeTab(item)}
					style={getStyle(selected)}
					key={item.key}
				>
					<img
						src={getIcons(selected ? item.activeIcon : item.InActiveIcon, operator)}
						alt={item.label}
						style={{
							width: 40,
							height: 23,
						}}
						className="bookticketicon"
					/>
					{item.label}
				</div>) : (<div
					className={`${tabs.length > 2 && 'flex1'} tab d-flex-c bold-text`}
					onClick={() => handleChangeTab(item)}
					style={getStyle(selected)}
					key={item.key}
				>
					<img
						src={getIcons(selected ? item.activeIcon : item.InActiveIcon, operator)}
						alt={item.label}
						style={{
							width: 40,
							height: 23,
						}}
						className="bookticketicon"
					/>
					{item.label}
				</div>)

		);
	};

	return (

		<div className="themes-theme-ten-search-box ">
			{/*Start:  when you want to show search option in santajauna remove below style and */}
			{/* <style>
				{`
          .hidden {
            display: none;
          }
        `}
			</style> */}

			{/*End:  Remove style in between Start and End  comments to show search box for santajuanga  also remove */}
			<div className="new-container">

				{/* // uncomment below line to show search box for santajuana */}
				{/* <div className="home-main-selection-container"> */}
				{/* // uncomment below line to show search box for santajuana */}


				{/* {Comment or Remove below line to show search box in santajuana} */}
				<div className={`home-main-selection-container ${operator.operator_name === 'santajuana' ? 'hidden' : ''}`}>
					{/* {Comment or Remove above line to show search box in santajuana} */}
					<div className="tabs f-14">
						{tabs.map(val => {
							return tabItem(val);
						})}
					</div>
					<div
						className="kupos-card  kupos-card-padding-l"
						style={{ borderTopRightRadius: 0, borderTopLeftRadius: 0 }}
					>
						{selectedTab.component(props, changeTicket)}
					</div>
				</div>
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
		home: state.home,
		common: state.common,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(
			{
				...actions,
				...serviceActions,
				...myAccountActions,
				...commonActions,
				...homeActions,
			},
			dispatch,
		),
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withTranslation('common')(ThemeFourSearchBox));



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/common/ThemeFourSearchBox.js